import React from 'react';
import { Grid } from '@mui/material';

export const GridContainer = (props: any) => <Grid container spacing={2} {...props} />;

export const GridItem = (props: any) => <Grid item {...props} />;
